import module from 'nominas/nomina/module.js'
import template from './template.html'

const validarPagosCuentas = (pagos) => {
  return pagos.every((pago) => pago.id_metodo_pago !== 1 || pago.banco_id)
}

const validarPagosTransferencia = (pagos) => {
  return pagos.every((pago) => pago.id_metodo_pago > 0)
}

const validarPagosVacios = (pagos) => {
  return pagos.every((pago) => pago.importe > 0)
}

export class NominasNominaConfiguracionPagosColaboradorComponent {
  data
  tipoCambio
  onChange

  $onInit () {
    if (this.data.pagos.length === 0) {
      let pago = this.generarPago()

      if (this.data.cuentas_bancarias.length) {
        let banco = this.data.cuentas_bancarias.find((item) => item.id_moneda === this.data.id_moneda)

        if (!banco) {
          banco = this.data.cuentas_bancarias[0]
        }

        pago.id_metodo_pago = 1
        pago.id_moneda = banco.id_moneda
        pago.banco_id = banco.id_banco
        pago.banco_cuenta = banco.cuenta
        pago.banco_clabe = banco.clabe
        pago.banco_tarjeta = banco.tarjeta
      } else {
        pago.id_metodo_pago = 2
      }

      if (pago.id_metodo_pago === 1 && pago.id_moneda === 2 && pago.banco_id !== '005') {
        pago.id_metodo_pago = 2
      }

      this.data.pagos.push(pago)
    }

    this.validar()
  }

  agregar () {
    this.data.pagos.push(this.generarPago())
    this.validar()
  }

  aprobar (status) {
    this.data.status_aprobado = status
    this.validar()
  }

  eliminar (item) {
    if (!item.eliminable) return

    item.eliminado = true

    if (!item.id_pago) {
      this.data.pagos = this.data.pagos.filter(item => !item.eliminado)
    }

    this.validar()
  }

  generarPago () {
    return {
      id_pago: null,
      eliminado: false,
      modificado: false,
      editable: true,
      eliminable: true,
      id_metodo_pago: undefined,
      id_moneda: this.data.id_moneda,
      tipo_cambio: this.data.id_moneda === 1 ? 1 : this.tipoCambio,
      importe: this.data.total - this.total,
      observaciones: '',
      banco_id: null,
      banco_cuenta: null,
      banco_clabe: null,
      banco_tarjeta: null,
      status_pagado: false,
    }
  }

  validar () {
    this.total = parseFloat(this.data.pagos.reduce((total, item) => item.eliminado ? total : total + item.importe, 0).toFixed(2))
    
    if(this.total > this.data.montoMaximo){
      this.data.$$error = `Existe una duplicacion de un pago de ${this.total} cuando el monto maximo es de ${this.data.montoMaximo}`

      this.data.$$valido = !this.data.$$error
      this.onChange({$event: {data: this.data}})
      return
    }

    if (!validarPagosVacios(this.data.pagos)) {
      this.data.$$error = 'Los pagos deben de tener un importe mayor a cero'
    } else if (!validarPagosTransferencia(this.data.pagos)) {
      this.data.$$error = 'Es necesario especificar el método de pago'
    } else if (!validarPagosCuentas(this.data.pagos)) {
      this.data.$$error = 'Es necesario especificar la cuenta bancaria'
    } else if (this.total !== this.data.total) {
      let diferencia = +(this.data.total - this.total).toFixed(2)
      this.data.$$error = `Existe una diferencia de ${diferencia} entre La suma de los pagos y el total a pagar`
    } else {
      this.data.$$error = null
    }

    this.data.$$valido = !this.data.$$error

    this.onChange({$event: {data: this.data}})
  }
}

module.component('nominasNominaConfiguracionPagosColaborador', {
  controller: NominasNominaConfiguracionPagosColaboradorComponent,
  template,
  bindings: {
    data: '<',
    tipoCambio: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/configuracion/pagos/colaborador/component.js